import React from "react";
import { useState } from "react";

export default function Pagination() {

    const [activePage, setActivePage] = useState(1);

    const handlePageClick = (page) => {
        setActivePage(page);
    };

    const totalPages = 2;

    const pages = Array.from({ length: totalPages }, (_, index) => index + 1);
    return (
        <div className="paginations">
            <ul className="spans flex">

                <li>
                    <button
                        className="page-link"
                        onClick={() => setActivePage(activePage > 1 ? activePage - 1 : 1)}
                        disabled={activePage === 1}
                    >
                        <img src={require("../../assets/icons/arrowPrev.svg").default} alt="Previous" />
                    </button>
                </li>


                {pages.map((page) => (
                    <li key={page}>
                        <button
                            className={`page-link ${activePage === page ? 'active' : ''}`}
                            onClick={() => handlePageClick(page)}
                        >
                            {page}
                        </button>
                    </li>
                ))}

                {/* Next Arrow */}
                <li>
                    <button
                        className="page-link"
                        onClick={() => setActivePage(activePage < totalPages ? activePage + 1 : totalPages)}
                        disabled={activePage === totalPages}
                    >
                        <img src={require("../../assets/icons/arrowNext.svg").default} alt="Next" />
                    </button>
                </li>
            </ul>
            <div>Showing 1 - 5 of 5</div>
        </div>
    );
}